module.exports = __webpack_public_path__ + "img/babybook-tile-info.bc6896a1.svg";